module.exports = __webpack_public_path__ + "img/telefono-outlined.9096e0b3.svg";